export function normalizeCompetitiveness(value: number) {
  return value ? value * 100 : 0;
}

export function normalizeMargin(value: number) {
  return value ? value * 100 : 0;
}
